// extracted by mini-css-extract-plugin
module.exports = {"list":"InfoBlock_list__1zals","item":"InfoBlock_item__KlaSh","value":"InfoBlock_value__tSl1Z","valueSkeleton":"InfoBlock_valueSkeleton__nJgrT"};